import { Fragment } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'rizzui';
import PageHeader from '../../../layout/shared/page-header';
import { menuRoutes } from '../../../router/menu';
import FacilitatorPendingExtras from './FacilitatorPendingExtras';

const FacilitatorPendingExtrasWrapper = () => {
    const navigate = useNavigate();

    return (
        <Fragment>
            <PageHeader
                title="Extras pendientes"
                breadcrumb={[
                    { name: 'Ventas' },
                    { name: 'Gestión de campañas' },
                    { name: 'Extras pendientes', href: menuRoutes.calls.path + menuRoutes.calls.pendingExtras },
                ]}
            >
            </PageHeader>
            <FacilitatorPendingExtras />
        </Fragment>
    );
};

export default FacilitatorPendingExtrasWrapper;
